import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import CustomerActions from "../../Redux/Actions/CustomerActions";
import PaymentSuccessModal from "./PaymentSuccessModal";

const PaymentModal = ({
  paymentshow,
  handlePaymentClose,
  id,
  data,
  type
}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handlePay = async () => {
   const payload = {
    [type === "task" ? "task_id" : "bookingId"]: id,
  };
    if(type ==='booking'){
      const res = await dispatch(CustomerActions?.payBooking(payload));
      if (res?.payload?.success) {
        handlePaymentClose();
        window.location.href = `${res?.payload?.paymentUrl}`;
      }
    }else{
      const resTask = await dispatch(CustomerActions?.payTask(payload));
      if (resTask?.payload?.success) {
        handlePaymentClose();
        window.location.href = `${resTask?.payload?.paymentUrl}`;
      }
    }
  };
  const handleClose = () => setShow(false);
  
  // Find the quotation that matches the task's quatation_id
  const matchingQuotation = data?.task?.quatation_id && Array.isArray(data?.quotations) 
    ? data.quotations.find(q => q._id === data.task.quatation_id)
    : null;
  
  // Get the price from matching quotation, otherwise use budget or default
  const payment = matchingQuotation?.offer_price 
    ? matchingQuotation.offer_price 
    : data?.task?.budget || '';
  
  return (
    <div>
      <Modal show={paymentshow} onHide={handlePaymentClose} centered>
        <Modal.Body>
          <div className="comman-small-pop">
            <div className="center-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="61"
                height="61"
                viewBox="0 0 61 61"
                fill="none"
              >
                <path
                  d="M0.54669 32.2327C0.537783 32.0754 0.528876 31.918 0.522938 31.7606C0.499186 31.1727 0.493248 30.5818 0.508093 29.9939C0.522938 29.406 0.552628 28.8181 0.603101 28.2332C0.653575 27.6482 0.721862 27.0633 0.807963 26.4843C0.894064 25.9023 0.997979 25.3263 1.11971 24.7502C1.24144 24.1742 1.37801 23.6041 1.5324 23.037C1.68679 22.4699 1.85899 21.9057 2.04604 21.3504C2.23308 20.7922 2.43498 20.2399 2.65468 19.6936C2.87439 19.1473 3.10597 18.6069 3.35537 18.0724C3.60476 17.5379 3.869 17.0124 4.14512 16.4927C4.42421 15.9731 4.71517 15.4624 5.02395 14.9576C5.32975 14.4529 5.65041 13.96 5.9859 13.473C6.31843 12.9861 6.66581 12.511 7.02802 12.0448C7.38727 11.5786 7.76137 11.1214 8.14734 10.676C8.53331 10.2306 8.93116 9.79708 9.33791 9.37248C9.74763 8.95085 10.1692 8.53812 10.5997 8.14024C11.0332 7.74236 11.4756 7.35636 11.9298 6.98223C12.3841 6.61108 12.8502 6.2518 13.3253 5.9044C13.8003 5.55996 14.2843 5.22741 14.7801 4.91267C15.2759 4.59792 15.7806 4.29506 16.2943 4.01001C16.8079 3.72496 17.3305 3.45476 17.8619 3.20238C18.3934 2.94999 18.9337 2.71542 19.483 2.49569C19.5364 2.47491 19.5869 2.45412 19.6404 2.43334C31.3768 -2.14822 45.8715 1.64055 53.864 11.3916C61.8566 21.1426 62.7325 36.0987 55.9305 46.7138C49.1285 57.3289 35.1742 62.7834 22.9775 59.5944C22.4193 59.4489 21.8671 59.2856 21.3178 59.1045C20.7686 58.9234 20.2252 58.7244 19.6879 58.5106C19.1505 58.2968 18.622 58.0652 18.0994 57.8188C17.5769 57.5723 17.0633 57.3081 16.5556 57.0319C16.0479 56.7558 15.552 56.4618 15.0621 56.156C14.5723 55.8502 14.0913 55.5295 13.6192 55.194C13.1471 54.8584 12.684 54.511 12.2327 54.1518C11.7814 53.7925 11.336 53.4184 10.9055 53.0324C10.4721 52.6464 10.0505 52.2485 9.64075 51.8417C9.23102 51.4319 8.83021 51.0133 8.44127 50.5827C8.05233 50.1522 7.67527 49.7098 7.31305 49.2614C6.94786 48.8101 6.59752 48.3498 6.25905 47.8807C5.92059 47.4116 5.594 46.9305 5.27928 46.4436C4.96754 45.9566 4.66767 45.4608 4.38264 44.956C4.09762 44.4512 3.82447 43.9405 3.56914 43.4239C3.31083 42.9072 3.07034 42.3816 2.84173 41.8502C2.61609 41.3187 2.40232 40.7812 2.20636 40.2379C2.01041 39.6945 1.8293 39.1452 1.666 38.5929C1.50271 38.0406 1.35426 37.4794 1.22362 36.9182C1.09299 36.3541 0.980165 35.7899 0.882188 35.2198C0.78718 34.6497 0.707017 34.0767 0.647637 33.5006C0.60607 33.073 0.570442 32.6544 0.54669 32.2327ZM26.3978 34.9704C26.1415 35.2267 25.7643 35.3072 25.4969 35.0625C24.4843 34.1353 23.5446 33.2713 22.6004 32.4139C20.9348 30.8996 19.3138 29.3288 17.5858 27.8887C15.9766 26.5466 13.4826 27.4226 12.9928 29.4268C12.678 30.7095 13.1085 31.7636 14.0735 32.6395C17.3067 35.5732 20.534 38.5187 23.7613 41.4612C25.3557 42.9131 26.9203 42.8805 28.4613 41.3513C34.6487 35.2109 40.8331 29.0705 47.0175 22.9301C47.2105 22.7371 47.4065 22.5441 47.5816 22.3333C48.9652 20.6735 48.2437 18.1763 46.1832 17.5201C44.8561 17.0955 43.7902 17.5587 42.8431 18.5089C37.3653 24.002 31.8786 29.4803 26.3978 34.9704Z"
                  fill="#0f5c4c"
                />
              </svg>
            </div>
            <p className="mb-3">
              Your service has been completed. Please pay to
              <br /> proceed further.
            </p>
            <h5>$ {data?.serviceSubCategory?.price || payment || data?.budget}</h5>
            {/* <h5>$ {data?.serviceSubCategory?.price || data?.budget}</h5> */}
            <div className="comman-pop-action">
              <button className="btn-fill" onClick={handlePay}>
                Pay Now
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <PaymentSuccessModal show={show} handleClose={handleClose} />
    </div>
  );
};

export default PaymentModal;
